import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.maxStep = 1;
router.previousRoute = null;
router.funnelSubtype = null;

router.goToStep = (step, params) => {
  router.maxStep = step;
  const { query } = router.app.$route;
  const route = router.options.routes.find((r) => r.meta?.step === step);
  router.push({ name: route.name, params: params || {}, query });
};

router.beforeEach((to, from, next) => {
  /*
  * ESignature thank-you redirect
  * */
  if (to.name === 'ESignatureSuccess' || to.name === 'ESignatureFail' || to.name === 'ESignatureIdentityFail') {
    next();
    return;
  }
  /*
  * If max step is 12, that means user is in some of thank-you pages
  * and then he cannot go anywhere.
  * */
  if (router.maxStep === 23) return;
  /*
  * Routes after save but before any thank-you page. (EID, eSignature, SaveForLater/Contact ...).
  * User cannot go back to application from this routes.
  * */
  // todo: toto zatial neviem
  if (router.maxStep > 20 && router.maxStep < 23 && to.meta?.step < 21) return;
  /*
  * Movement between steps
  * */
  if (router.maxStep >= to.meta?.step) next();
  else {
    const route = router.options.routes.find((r) => r.meta?.step === router.maxStep);
    router.push({ name: route.name, query: to.query });
  }
});

export default router;
